/*
 * $Id:: UserInfoMobile.js 2020/11/12 06:07 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useRef, useEffect } from 'react';

import { Button } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';

import SupervisedUser from '../../assets/images/supervised_user_circle_24px.svg';
import { t } from '../../providers';

const useStyles = makeStyles((theme) => ({
    dashboardButton: {
        '& svg': {
            fill: 'black',
            opacity: '.54',
            width: '24px !important',
        },
    },
    mobileMenu: {
        position: 'absolute',
        top: '87px',
        left: '0',
        right: '0',
        background: '#ffffff',
        padding: '35px 29px 15px',
        boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.1), 0px 3px 4px rgba(0, 0, 0, 0.02), 0px 2px 4px rgba(0, 0, 0, 0.04)',
    },
    userArea: {
        display: 'flex',
        flexFlow: 'row nowrap',
        marginRight: '2rem',
    },
    userInfo: {
        marginLeft: '4px',
        display: 'inline-grid',
    },
    userRole: {
        color: '#4D4D4D',
        lineHeight: '12px',
        letterSpacing: '0',
        fontSize: '0.625rem',
        fontWeight: '600',
    },
    userName: {
        fontSize: '0.875rem',
        fontWeight: '600',
        lineHeight: '16px',
        color: theme.palette.svg.main,
        letterSpacing: '0',
    },
    divider: {
        margin: '15px 0',
    },
    logout: {
        color: theme.palette.error.border,
        cursor: 'pointer',
        fontSize: '0.875rem',
        lineHeight: '20px',
    },
    buttonLink: {
        margin: '0 23px 0 0 !important',

        padding: '0px',
        '& svg path': {
            fill: 'rgba(0, 0, 0, 0.54)',
        },
        '& .MuiButton-label': {
            color: theme.palette.svg.main,
        },
    },
}));

const UserinfoMobile = ({ user, logout }) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const accountDetails = user.userDetails && user.userDetails.accountTypeDetails;

    // set role
    let role = '';
    if (user.userRole) {
        role = user.userRole;
    } else {
        if (user.userType === 'CHILD' && accountDetails) {
            role = accountDetails.personType;
        }
    }

    const handleMenuVisibility = () => {
        setOpen(!open);
    };

    /* catch click outside mobile menu and then hide it */
    const targetComponent = useRef();

    const handleClickOutside = (e) => {
        if (targetComponent.current.contains(e.target)) {
            // inside click --> do nothing
            return;
        }
        // outside click --> close menu
        setOpen(false);
    };

    useEffect(() => {
        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open]);
    /* end of catch click outside mobile menu and the hide the section */

    return (
        <div ref={targetComponent}>
            <IconButton
                color="inherit"
                aria-label={t('header.menu.right')}
                onClick={handleMenuVisibility}
                edge="start"
                className={classes.dashboardButton}>
                <DashboardOutlinedIcon aria-hidden="true" focusable="false" />
            </IconButton>
            {/** mobile menu */}
            {open && (
                <div className={classes.mobileMenu}>
                    <div className={classes.userArea}>
                        <img src={SupervisedUser} alt={t('header.icon')} />
                        <div className={classes.userInfo}>
                            <Typography variant="body2" className={classes.userName}>
                                {user.fullName}
                            </Typography>
                            <Typography variant="overline" className={classes.userRole}>
                                {role ? t(role.toLowerCase()) : ''}
                            </Typography>
                        </div>
                    </div>
                    <Divider className={classes.divider} />
                    <Button id="logout-mobile" onClick={logout} className={classes.logout}>
                        {t('log.out')}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default UserinfoMobile;
